import {
  SetClientNotificationRequest,
  SetClientNotificationCommandResult,
  putOrdersPublicIDClientNotifications,
} from "Api/Api";
import { createAsyncAction, getType } from "typesafe-actions";
import { call, put, takeLatest } from "typed-redux-saga";
import { createSlice } from "@reduxjs/toolkit";
import { mapAPIErrorResponse } from "Models/Errors/ApiCallError";
import {
  getFetchStateDefaultValue,
  handleFailureCase,
  handleRequestCase,
  handleSuccessCase,
} from "State/Utils";
import { getOrderDetailAsync } from "State/Orders/Detail/OrderDetailSlice";

export const setClientNotificationAsync = createAsyncAction(
  "@order/SET_CLIENT_NOTIFICATION_REQUEST",
  "@order/SET_CLIENT_NOTIFICATION_RESPONSE",
  "@order/SET_CLIENT_NOTIFICATIONFAILURE",
)<
  { request: SetClientNotificationRequest; publicID: string },
  SetClientNotificationCommandResult,
  Error
>();

function* setClientNotification(
  action: ReturnType<typeof setClientNotificationAsync.request>,
): Generator {
  try {
    const { data, error, status } = yield* call(
      putOrdersPublicIDClientNotifications,
      action.payload.request,
      action.payload.publicID,
    );

    if (status === 200) {
      yield put(
        getOrderDetailAsync.request({ publicID: action.payload.publicID }),
      );
      yield put(setClientNotificationAsync.success(data));
      return;
    }

    yield put(
      setClientNotificationAsync.failure(mapAPIErrorResponse(error ?? data)),
    );
  } catch (err) {
    yield put(setClientNotificationAsync.failure(err as Error));
  }
}
export function* setClientNotificationSaga() {
  yield takeLatest(
    getType(setClientNotificationAsync.request),
    setClientNotification,
  );
}

export const setClientNotificationSlice = createSlice({
  initialState:
    getFetchStateDefaultValue<SetClientNotificationCommandResult>(false),
  name: "@order/setClientNotification",
  reducers: {
    resetSlice: () =>
      getFetchStateDefaultValue<SetClientNotificationCommandResult>(false),
  },
  extraReducers: builder => {
    handleRequestCase(setClientNotificationAsync, builder);
    handleSuccessCase(setClientNotificationAsync, builder);
    handleFailureCase(setClientNotificationAsync, builder);
  },
});

export const { resetSlice } = setClientNotificationSlice.actions;
